import UserName from 'app/shared-components/user/UserName';
import ChannelName from 'app/shared-components/channel/ChannelName';

function ArticleAuthorName({ article, ...props }) {
  if (article?.userAuthor) {
    return <UserName user={article.userAuthor} {...props} />;
  }
  
  if (article?.organizationAuthor) {
    return <ChannelName channel={article.organizationAuthor} {...props} />;
  }
  
  return null;
}

export default ArticleAuthorName;